import React from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { FormGroup, Button, Intent } from '@blueprintjs/core';
import FormDrawer from 'components/FormDrawer';
import { FormSection, FieldError } from 'components/FormBits';
import { VacationDates, defaultVacationDates, validateVacationDates, focusFirstError } from 'components/User/VacationModal';
import moment from 'moment';
import Toast from 'helpers/toaster';
import TechnicianPicker from 'components/TechnicianPicker';

// Add a vacation for anyone on the team: who, then when (quick ranges or
// exact dates), notes folded away.
@inject('userStore') @observer
class NewVacationModal extends React.Component {

  @observable minDateStart = moment().subtract(5, 'month');
  @observable errors = {};
  @observable showErrors = false;

  componentDidMount() {
    if (this.props.isOpen) this.onOpen();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) this.onOpen();
  }

  onOpen() {
    this.errors = {};
    this.showErrors = false;
    defaultVacationDates(this.props.userStore.new_vacation.object);
  }

  validate() {
    const { object } = this.props.userStore.new_vacation;
    const errors = validateVacationDates(object);
    if (!object.user_id || !object.user_id.length) errors.user = 'Choose who is going on vacation.';
    this.errors = errors;
    return errors;
  }

  persistVacation() {
    const {
      userStore,
    } = this.props;

    let promise = userStore.createUserVacation()


    promise
      .then(this.onSuccessfullCreateOrUpdateVacation.bind(this))
      .catch(this.onFailureCreateOrUpdateVacation.bind(this))
  }

  onSuccessfullCreateOrUpdateVacation(response) {
    this.props.onClose()
  }

  onFailureCreateOrUpdateVacation(error) {
    Toast.show({ message: error.response.data.errors, intent: Intent.DANGER })
  }

  handleCloseVacationDailog() {
    this.props.onClose()
  }

  handleStartDateChange(time) {
    let { object } = this.props.userStore.new_vacation;
    if(time) {
      object.start_date = moment(time)
    }
    if (this.showErrors) this.validate();
  }

  handleEndDateChange(time) {
    let { object } = this.props.userStore.new_vacation;
    if(time) {
      object.end_date = moment(time)
    }
    if (this.showErrors) this.validate();
  }

  onTechnicianChange(technicians) {
    let { object } = this.props.userStore.new_vacation;
    let selectedValues = technicians.map((status) => status.value);
    object.user_id = selectedValues;
    if (this.showErrors) this.validate();
  }

  createVacation() {
    this.showErrors = true;
    const errors = this.validate();
    if (Object.keys(errors).length) {
      focusFirstError([
        errors.user && 'new-vacation-user',
        errors.start && 'new-vacation-start',
        errors.end && 'new-vacation-end',
      ].filter(Boolean));
      return;
    }
    this.props.userStore.createTechnicianVacation()
      .then(this.onSuccessfullCreateVacation.bind(this))
      .catch(this.onFailureCreateVacation.bind(this))
  }

  onSuccessfullCreateVacation(response) {
    this.props.onClose()
    Toast.show({ icon: 'thumbs-up', message: 'Vacation added successfully.', intent: Intent.SUCCESS })
  }

  onFailureCreateVacation(error) {
    Toast.show({ icon: 'warning-sign', message: error.response.data.errors, intent: Intent.DANGER })
  }

  render() {
    const {
      isOpen,
      userStore: {
        new_vacation: {
          isLoading,
          object
        }
      }
    } = this.props;
    const busy = !!isLoading;
    const close = this.handleCloseVacationDailog.bind(this);
    const errors = this.showErrors ? this.errors : {};
    return(
      <FormDrawer
        title="Add vacation"
        icon="airplane"
        size="min(760px, 100vw)"
        isOpen={isOpen}
        onClose={close}
        busy={busy}
        footer={
          <>
            <Button text="Cancel" onClick={close} disabled={busy} />
            <Button
              intent={Intent.PRIMARY}
              icon="add"
              text="Add vacation"
              loading={busy}
              onClick={this.createVacation.bind(this)}
            />
          </>
        }
      >
        <FormSection title="Who" hint="The person who'll be away. Office staff are listed too.">
          <div id="new-vacation-user" className={errors.user ? 'has-error' : ''}>
            <FormGroup label="Person" labelInfo={<span className="fb-required">*</span>}>
              <TechnicianPicker
                selectedOptions={object.user_id}
                onChange={this.onTechnicianChange.bind(this)}
                maximumSelections={1}
                showUser
                includeAdmins
              />
              <FieldError>{errors.user}</FieldError>
            </FormGroup>
          </div>
        </FormSection>

        <FormSection title="When" hint="Pick a quick range or set exact start and end times.">
          <VacationDates
            object={object}
            errors={errors}
            minDate={this.minDateStart}
            idPrefix="new-vacation"
            onStartChange={this.handleStartDateChange.bind(this)}
            onEndChange={this.handleEndDateChange.bind(this)}
          />
          <FormGroup label="Notes" labelFor="new-vacation-notes">
            <input
              id="new-vacation-notes"
              type='text'
              className='bp3-input bp3-fill'
              placeholder='e.g. Family trip, back Monday'
              defaultValue={object.notes}
              onChange={(event) => { object.notes = event.target.value } }
            />
          </FormGroup>
        </FormSection>
      </FormDrawer>
    )
  }

};

export default NewVacationModal;
